import { MEDIA_RULES, isDocumentMediaKind } from '../constants/limits';
import { MEDIA_ASSET_KINDS } from './enums';
const SIGNATURES = MEDIA_RULES.imageMagicBytes;
/** İmza kontrolü için okunması gereken bayt sayısı (en uzak kural + uzunluğu). */
export const IMAGE_SIGNATURE_PREFIX_BYTES = Object.values(SIGNATURES).reduce((max, rules) => {
    for (const rule of rules ?? []) {
        max = Math.max(max, rule.offset + rule.bytes.length / 2);
    }
    return max;
}, 0);
/** Görsel medya türlerinin çalışma zamanı listesi (kapılar ve testler sayar). */
export const IMAGE_MEDIA_KINDS = MEDIA_ASSET_KINDS.filter((kind) => !isDocumentMediaKind(kind));
/**
 * İlk baytlar beyan edilen görsel tipiyle uyuşuyor mu.
 *
 * Bilinmeyen tip `false` döner — "kural yoksa geç" bir kapı değil süs olurdu.
 */
export function imageSignatureMatches(mimeType, head) {
    const rules = SIGNATURES[mimeType];
    if (!rules || rules.length === 0)
        return false;
    return rules.every((rule) => {
        const expected = rule.bytes.toLowerCase();
        for (let index = 0; index < expected.length / 2; index += 1) {
            const actual = head[rule.offset + index];
            if (actual === undefined)
                return false;
            if (actual.toString(16).padStart(2, '0') !== expected.slice(index * 2, index * 2 + 2)) {
                return false;
            }
        }
        return true;
    });
}
//# sourceMappingURL=media-signature.js.map